import styled from 'styled-components'
import Image from 'next/legacy/image'
import Wrapper from 'common/wrapper'
import { usePortfolio } from 'querys/portfolio'
import useIntersectionObserver from 'hooks/use-intersection-observer'
import SocialMedia from './social-media'

const PortfolioHeroStyled = styled.section`
  text-align: center;
  margin-block-start: -72px;
  padding-block-start: calc(16px + 72px);
  padding-block-end: 48px;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-image: url('/images/portfolio/portfolio-pattern-mobile.svg');
  &::after {
    position: absolute;
    height: 48px;
    right: 0;
    left: 0;
    background: linear-gradient(0deg, #04001e, transparent);
    bottom: 0;
    content: "";
  }
  .user-photo {
    inline-size: 128px;
    block-size: 128px;
    margin: 0 auto;
    padding: 4px;
    border-radius: 50%;
    background-image: linear-gradient(51.32deg, rgb(250, 5, 124) 0%, rgb(7, 4, 254) 100%, rgba(196, 196, 196, 0) 100%);
    box-sizing: border-box;
    &-container {
      inline-size: 120px;
      block-size: 120px;
      border-radius: 50%;
      overflow: hidden;
    }
  }
  .hi {
    font: var(--headline3);
    font-weight: 700;
    margin-block-start: 24px;
    margin-block-end: 16px;
  }
  .user-fullname {
    font: var(--headline5);
    font-weight: 700;
    margin-block-end: 24px;
  }
  .user-description {
    max-inline-size: 700px;
    margin: 24px auto;
    font-size: 18px;
    line-height: 27px;
  }
  @media (min-width: 1024px) {
    background-image: url('/images/portfolio/portfolio-pattern.svg');
    padding-block-start: calc(48px + 72px);
    padding-block-end: 48px;
    .user-fullname {
      font-size: 80px;
      line-height: 98px;
    }
    .hi {
      font-size: 100px;
      line-height: 122px;
    }
    .user-photo {
      inline-size: 200px;
      block-size: 200px;
      padding: 8px;
      &-container {
        inline-size: 184px;
        block-size: 184px;
      }
    }
  }
`

function PortfolioHero() {
  const {
    data: {
      full_name, title, description, big_photo,
    },
  } = usePortfolio()

  const handleIntersect = (entries) => {
    const header = document.querySelector('#navigation')
    if (entries.boundingClientRect.y < 0) {
      header.classList.add('dark')
    } else {
      header.classList.remove('dark')
    }
  }

  const { ref: photoRef } = useIntersectionObserver({ handleIntersect, rootMargin: '0px 0px -100% 0px' } )

  return (
    <PortfolioHeroStyled aria-labelledby="fullname" id="hola">
      <Wrapper maxWidth={845}>
        <div className="user-photo" ref={photoRef}>
          <div className="user-photo-container">
            <Image width={184} height={184} src={big_photo} alt={full_name} />
          </div>
        </div>
        <p className="hi">¡Hola!</p>
        <h1 className="user-fullname" id="fullname">
          {title || `Soy ${full_name}`}
        </h1>
        <p className="user-description">
          {description}
        </p>
        <SocialMedia />
      </Wrapper>
    </PortfolioHeroStyled>
  )
}

export default PortfolioHero
